import axios from "axios"
import dayjs from "dayjs"

export const ETLService = () => {
  const URL_BASE = `${process.env.REACT_APP_TERA_ETL}`
  const URL_BASE_UPLOAD = `${process.env.REACT_APP_TERA_ETL}/upload`

  const getUploadedFiles = async (token) => {
    const {
      data: { files },
    } = await axios.get(URL_BASE_UPLOAD, { headers: { Authorization: `Bearer ${token}` } })

    return files
  }

  const upload = async (token, file, dataset, date) => {
    const {
      data: { url },
    } = await axios.get(`${URL_BASE_UPLOAD}/${dataset}/${date?.format("YYYY/MM/DD")}/presigned-url`, {
      headers: { Authorization: `Bearer ${token}` },
    })

    await axios.put(url, file, { headers: { "Content-Type": file.type } })
  }

  const triggerColdStart = async (token) => {
    try {
      await axios.get(`${URL_BASE_UPLOAD}/dataset/${dayjs().format("YYYY/MM/DD")}/presigned-url?cold_start=true`, {
        headers: { Authorization: `Bearer ${token}` },
      })
    } catch (error) {
      console.error("Error triggering cold start:", error)
    }
  }

  const forceAddeparReprocessing = async (token) => {
    try {
      await axios.post(
        `${URL_BASE}/positions/reprocess`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
    } catch (error) {
      console.error("Error triggering Addepar reprocessing:", error)
    }
  }

  return { getUploadedFiles, upload, triggerColdStart, forceAddeparReprocessing }
}
